module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"wrongDomain":"Cette page n\u0027est pas consultable depuis ce domaine."},"en":{"wrongDomain":"This page cannot be accessed from this domain."}}')
  delete Component.options._Ctor
}
